import { RRIInputOption } from './input-option.interface';

export interface RRIDropdownOptionTemplate<T> {
  item: RRIInputOption<T>;
  index: number;
  match: any;
  query: string[] | string;
}
